import React from 'react';
import strings from 'strings';

import { Banner } from '../Banner';
import * as styles from './SafetyBanner.scss';

const SafetyBanner = (props) => {
  const {
    safetyLandingUrl,
    closeBanner,
    imageUrl,
  } = props;

  return (
    <Banner
      url={safetyLandingUrl}
      closeBanner={closeBanner}
      primaryText={strings.safetyBannerPrimary}
      secondaryText={strings.safetyBannerSecondary}
      buttonText={strings.safetyBannerBtn}
      imageUrl={imageUrl}
      imageAlt="safety-image"
      className={styles.safetyBanner}
    />
  );
};

export default SafetyBanner;
